/*
Monotype Foundry Platform API
Version 1.0.0

Definition: BinariesDeleteRequest

Properties:
  binaries: array
*/

var BinariesDeleteRequest = (function () {
  function validateBinariesDeleteRequest (arg) {
    // Validate binaries
    if (arg.binaries && !(Array.isArray(arg.binaries))) {
      throw new Error('BinariesDeleteRequest.binaries: Wrong type: Got \'' + (typeof arg.binaries) + '\', but expected: \'array\'')
    }
  }
  function buildBinariesDeleteRequest (arg) {
    var BinariesDeleteRequest = arg
    // Complete binaries
    // Expected Type: array
    BinariesDeleteRequest.binaries = BinariesDeleteRequest.binaries || []
    return BinariesDeleteRequest
  }
  return {
    validate: validateBinariesDeleteRequest,
    build: buildBinariesDeleteRequest
  }
})()

module.exports = BinariesDeleteRequest
